import textStyles from './textStyles';

export const palette = {
  global01: '#e22a1d',
  global02: '#000000',
  global03: '#ffffff',
  global04: '#CCCCCC',
  neutral01: '#F2F2F2',
};

export const fonts = {
  primary: {
    bold: 'ITCAvantGardeStd, bold',
  },
  secondary: {
    light: 'Helvetica, light',
  },
};

export default {
  fonts,
  palette,
  textStyles,
};



// WEBPACK FOOTER //
// /opt/build/repo/src/app/config/branding.js